import { createFileRoute, getRouteApi } from "@tanstack/react-router";
import { PatientsShell } from "@/features/patients";
import { RecordGateContext } from "@/features/patients/record-gate";
import { requirePerm } from "@/lib/auth/guards";
import { can } from "@/lib/auth/permissions";

/**
 * `/patients` — the shell both patient routes stand in.
 *
 * The rail, the search, the status control and the pager live here
 * (`features/patients/patient-index.tsx`), so opening a row does not drop
 * the list or send a new search. The pane is the matched child: the index
 * (`patients.index.tsx`) is the nobody-chosen sentence, and
 * `patients.$patientId.tsx` is the record. `VIEW_PATIENT` gates both.
 *
 * THE EDIT GATE is computed here, where the session read already stands in
 * the eager graph, and carried to the record through `RecordGateProvider` —
 * the lazy record chunk reads a boolean instead of importing the session
 * modules (`record-gate.tsx` says what that costs otherwise).
 */
const authenticated = getRouteApi("/_authenticated");

export const Route = createFileRoute("/_authenticated/patients")({
  beforeLoad: requirePerm("VIEW_PATIENT"),
  component: function PatientsRoute() {
    const { session } = authenticated.useRouteContext();
    return (
      <RecordGateContext.Provider value={can(session, "EDIT_PATIENT")}>
        <PatientsShell />
      </RecordGateContext.Provider>
    );
  },
});
